import {
  NavController,
  AlertController,
  LoadingController,
  ToastController,
  Platform,
  ModalController,
} from '@ionic/angular';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Subscriber } from 'rxjs';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
} from '@angular/forms';
import { TranslationService } from 'src/i18n/translation-service';
import { RemoteHttpService } from 'src/remote-http';
import { RemoteRequest, ContentType } from 'src/remote-request';
import * as globals from 'src/globals';
import { adjustViewZIndex } from 'src/globals';
import { AuthenticationService } from 'src/authentication-service';
import { RemoteResponse } from 'src/RemoteResponse';
import { PlayerInfo } from 'src/data/player-data';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { PlayerService } from 'src/providers/player-service/player-service';
import { Country } from './country-location';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { HandicapSystem } from 'src/data/mygolf.data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { Custom_RequestMethod } from 'src/providers/common-service';
import { Router } from '@angular/router';
import { CountryListPage } from '../modal-screens/country-list/country-list.page';
import { CommonPullupMenuComponent } from '../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { Location } from '@angular/common';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.page.html',
  styleUrls: ['./sign-up.page.scss'],
})
export class SignUpPage implements OnInit {
  signupForm: FormGroup;
  handicapNo: number;
  firstName: AbstractControl;
  lastName: AbstractControl;
  handicap: AbstractControl;
  email: AbstractControl;
  password: AbstractControl;
  password2: AbstractControl;
  gender: AbstractControl;
  teeoff: AbstractControl;
  country: AbstractControl;
  nationality: AbstractControl;
  phone: AbstractControl;
  countryList: Array<Country>;
  selectedCountry: Country;
  handicapIndex: AbstractControl;
  // location: any;

  geoLong: number;
  geoLat: number;
  geoEnc: any;
  stringGeo: string;
  geoName: string;

  handicapSystems: Array<HandicapSystem>;
  handicapSystem: any;
  hcpIdx: number = 36;
  constructor(
    private fb: FormBuilder,
    private renderer: Renderer2,
    private translator: TranslationService,
    private http: RemoteHttpService,
    private auth: AuthenticationService,
    private nav: NavController,
    private alertCtl: AlertController,
    private loadingCtl: LoadingController,
    private platform: Platform,
    private toastCtl: ToastController,
    private playerService: PlayerService,
    private geolocation: Geolocation,
    private flightService: ClubFlightService,
    private requestMethod: Custom_RequestMethod,
    private router: Router,
    private modalCtrl: ModalController,
    private location: Location
  ) {
    // super();
    // this.signupForm = this.fb.group({
    //     firstName: new FormControl('', [<any>Validators.required, <any>Validators.maxLength(50)]),
    //     lastName : new FormControl('', [<any>Validators.maxLength(50)]),//['', Validators.compose([Validators.maxLength(50)])],
    //     handicap : new FormControl('24', [<any>Validators.required, <any>Validators.maxLength(50)]),//['', Validators.compose([Validators.required])],
    //     email    : new FormControl('', [<any>Validators.required, <any>Validators.maxLength(50)]),
    //     password : new FormControl('', [<any>Validators.required, <any>Validators.minLength(6), <any>Validators.maxLength(50)]),
    //     password2: new FormControl('', [<any>Validators.required, <any>Validators.minLength(6), <any>Validators.maxLength(50)]),
    //     gender   : new FormControl('M'),
    //     teeoff   : new FormControl('Blue'),
    //     country  : new FormControl(''),
    //     nationality : new FormControl(''),
    //     handicapSystem : new FormControl(''),
    // });

    this.signupForm = this.fb.group({
      firstName: new FormControl('', [
        <any>Validators.required,
        <any>Validators.maxLength(50),
      ]),
      lastName: new FormControl('', [<any>Validators.maxLength(50)]), //['', Validators.compose([Validators.maxLength(50)])],
      handicap: new FormControl('24', [
        <any>Validators.required,
        <any>Validators.maxLength(50),
      ]), //['', Validators.compose([Validators.required])],
      email: new FormControl('', [
        <any>Validators.required,
        <any>Validators.maxLength(50),
      ]),
      password: new FormControl('', [
        <any>Validators.required,
        <any>Validators.minLength(6),
        <any>Validators.maxLength(50),
      ]),
      password2: new FormControl('', [
        <any>Validators.required,
        <any>Validators.minLength(6),
        <any>Validators.maxLength(50),
      ]),
      gender: new FormControl('M'),
      teeoff: new FormControl('Blue'),
      country: new FormControl('MYS'),
      nationality: new FormControl('MYS'),
      handicapSystem: new FormControl(''),
      phone: new FormControl(null, [<any>Validators.required, <any>Validators.minLength(10), <any>Validators.maxLength(50)]),
      handicapIndex: new FormControl(54),

    });

    this.firstName = this.signupForm.controls['firstName'];
    this.lastName = this.signupForm.controls['lastName'];
    this.handicap = this.signupForm.controls['handicap'];
    this.email = this.signupForm.controls['email'];
    this.password = this.signupForm.controls['password'];
    this.password2 = this.signupForm.controls['password2'];
    this.gender = this.signupForm.controls['gender'];
    this.teeoff = this.signupForm.controls['teeoff'];
    this.country = this.signupForm.controls['country'];
    this.nationality = this.signupForm.controls['nationality'];
    this.handicapSystem = this.signupForm.controls['handicapSystem'];
    this.phone = this.signupForm.controls['phone']
    this.handicapIndex = this.signupForm.controls['handicapIndex']
  }

  ngOnInit() { }

  selectCountry(countryName: string) {
    this.selectedCountry = this.countryList
      .filter((c: Country) => {
        return c.name === countryName;
      })
      .pop();
  }

  generateAddress(addressObj) {
    let obj = [];
    let address = '';
    for (let key in addressObj) {
      obj.push(addressObj[key]);

      //   if(key === 'countryName') this.geoName = addressObj[key]
    }
    obj.reverse();
    for (let val in obj) {
      if (obj[val].length) address += obj[val] + ', ';
    }
    return address.slice(0, -2);
  }

  ionViewDidEnter() {
    adjustViewZIndex(this.nav, this.renderer);
    this.getCountry();
    this.refreshHandicapSystem();
  }
  onGenderChange(value) {
    // this.gender = value;
  }

  getCountry() {
    this.playerService.getCountryList().subscribe((data: Array<Country>) => {
      this.countryList = data;
    }),
      (error) => { },
      () => { };
  }

  async onSubmit(value: any) {
    //validate whether password1 and password 2 are same
    if (value.password !== value.password2) {

      let _message = {
        title: this.translator.translate('SignUpPage.password-mismatch-title'),
        content: this.translator.translate('SignUpPage.password-mismatch-message')
      }
        const modal = await this.modalCtrl.create({
          mode: 'ios',
          component: CommonPullupMenuComponent,
          cssClass: 'self-adjustable-modal',
          componentProps: {
              app: null,
              mode: 'infoDisplay',
              message: _message,
              showCancelBtn: false
          }
      })
      await modal.present().then(() => {
          const height = this.platform.height() - 250;
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
      modal.onDidDismiss().then((data: any) => {

      })

      // let alert = await this.alertCtl.create({
      //   header: this.translator.translate('SignUpPage.password-mismatch-title'),
      //   message: this.translator.translate(
      //     'SignUpPage.password-mismatch-message'
      //   ),
      //   buttons: [this.translator.translate('SignUpPage.alert-ok')],
      // });
      // await alert.present();
      return false;
    }


    // if (value.handicapIndex && (value.handicapIndex < -8 || value.handicapIndex > 54)) {
    if (this.hcpIdx && (this.hcpIdx < -8 || this.hcpIdx > 54)) {

      let _message = {
        title: 'Invalid Handicap Index Range', // this.translator.translate('SignUpPage.password-mismatch-title'),
        content: 'Please enter Handicap Index range of -8 to 54', // this.translator.translate('SignUpPage.password-mismatch-message')
      }
        const modal = await this.modalCtrl.create({
          mode: 'ios',
          component: CommonPullupMenuComponent,
          cssClass: 'self-adjustable-modal',
          componentProps: {
              app: null,
              mode: 'infoDisplay',
              message: _message,
              showCancelBtn: false
          }
      })
      await modal.present().then(() => {
          const height = this.platform.height() - 250;
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
      modal.onDidDismiss().then((data: any) => {

      })

      // let alert = await this.alertCtl.create({
      //   header: this.translator.translate('SignUpPage.password-mismatch-title'),
      //   message: this.translator.translate(
      //     'SignUpPage.password-mismatch-message'
      //   ),
      //   buttons: [this.translator.translate('SignUpPage.alert-ok')],
      // });
      // await alert.present();
      return false;
    }

    if (!value.handicap) {
      if (value.gender == 'M') {
        value.handicap = 24;
      } else {
        value.handicap = 36;
      }
    }

    if(this.hcpIdx) {
      value.handicapIndex = this.hcpIdx;
    }

    let headers = {};
    if (this.captchaResponse && this.captchaResponse.length > 0) headers['captcha-response'] = this.captchaResponse;
    else headers = null;
    let req = new RemoteRequest(
      globals.ServerUrls.registerPlayer,
      this.requestMethod.post,
      ContentType.URL_ENCODED_FORM_DATA,
      value, headers
    );

    let loading = await this.loadingCtl.create({
      showBackdrop: false,
      cssClass: 'nobg',
      message: 'Signing up...',
    });
    await loading.present().then(() => {
      this.http.execute(req).subscribe(
        (resp: any) => {
          if(resp) {
            this.router.navigate(['sign-in'], {replaceUrl: true});
          }
          // let prResult: PlayerInfo = resp;
          this.auth.setCurrenUser(resp.email);
          loading.dismiss().then(async () => {

            let _message = {
              title: 'Registration',
              content: 'Your registration was successful.<br>Please login with your email and password'
            }
              const modal = await this.modalCtrl.create({
                mode: 'ios',
                component: CommonPullupMenuComponent,
                cssClass: 'self-adjustable-modal',
                componentProps: {
                    app: null,
                    mode: 'messageSuccess',
                    message: _message,
                    showCancelBtn: false
                    // headerTitle: 'Registration',
                    // subTitle: 'You registration was successful.<br>Please login with your email and password',
                }
            })
            await modal.present().then(() => {
                const height = this.platform.height() - 250;
                document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
            });
            modal.onDidDismiss().then((data: any) => {
              console.debug("pullup dismiss", data)
              if(data) {
                // this.location.back();
              }
              // if(data)

            })
            // let alert = await this.alertCtl.create({
            //   header: 'Registration!',
            //   message:
            //     'You registration was successfull.<br>Please login with your email and password',
            //   buttons: [
            //     {
            //       text: 'OK',
            //       handler: () => {
            //         alert.dismiss().then(() => {
            //           this.router.navigate(['sign-in']);
            //         });
            //         return false;
            //       },
            //     },
            //   ],
            // });
            // alert.present();
          });
        },
        (error: any) => {
          let prResult = error;
          loading.dismiss().then(() => {
            if (prResult.error.errorMessage) {
              MessageDisplayUtil.showErrorToast(
                prResult.error.errorMessage,
                this.platform,
                this.toastCtl,
                5000,
                'bottom'
              );
            }
          });
        }
      );
    });
  }

  refreshHandicapSystem() {
    this.handicapSystems = [];
    this.flightService.getHandicapSystemList().subscribe((handicap: any) => {
      // Array<HandicapSystem>
      if (handicap && handicap.length > 0) {
        let _defHcpSystem;
        _defHcpSystem = handicap.filter((hcpSystem) => {
          if (
            !this.handicapSystem ||
            (this.handicapSystem && !this.handicapSystem.value)
          ) {
            if (hcpSystem.defaultSystem) return true;
            // this.handicapSystem.value = hcpSystem.id;
          }
          // hcpSystem.
        });
        this.handicapSystems = handicap;
        let _defHcpSys;
        if (_defHcpSystem && _defHcpSystem.length > 0)
          _defHcpSys = _defHcpSystem[0].id;

        this.signupForm = this.fb.group({
          firstName: new FormControl('', [
            <any>Validators.required,
            <any>Validators.maxLength(50),
          ]),
          lastName: new FormControl('', [<any>Validators.maxLength(50)]), //['', Validators.compose([Validators.maxLength(50)])],
          handicap: new FormControl('24', [
            <any>Validators.required,
            <any>Validators.maxLength(50),
          ]), //['', Validators.compose([Validators.required])],
          email: new FormControl('', [
            <any>Validators.required,
            <any>Validators.maxLength(50),
          ]),
          password: new FormControl('', [
            <any>Validators.required,
            <any>Validators.minLength(6),
            <any>Validators.maxLength(50),
          ]),
          password2: new FormControl('', [
            <any>Validators.required,
            <any>Validators.minLength(6),
            <any>Validators.maxLength(50),
          ]),
          gender: new FormControl('M'),
          teeoff: new FormControl('Blue'),
          country: new FormControl('MYS'),
          nationality: new FormControl('MYS'),
          handicapSystem: new FormControl(_defHcpSys),
          phone: new FormControl(null, [<any>Validators.required, <any>Validators.minLength(10), <any>Validators.maxLength(50)]),

        });
        this.firstName = this.signupForm.controls['firstName'];
        this.lastName = this.signupForm.controls['lastName'];
        this.handicap = this.signupForm.controls['handicap'];
        this.email = this.signupForm.controls['email'];
        this.password = this.signupForm.controls['password'];
        this.password2 = this.signupForm.controls['password2'];
        this.gender = this.signupForm.controls['gender'];
        this.teeoff = this.signupForm.controls['teeoff'];
        this.country = this.signupForm.controls['country'];
        this.nationality = this.signupForm.controls['nationality'];
        this.handicapSystem = this.signupForm.controls['handicapSystem'];
        this.phone = this.signupForm.controls['phone'];
      }
    });
  }

  backRouting() {
    this.router.navigate(['sign-in']);
  }
  getCountryInfo(countryId, type: string) {

    if (!this.countryList) return;
    if (!this.signupForm.value['country'] && type === 'country')
      return 'Tap here to select';
    if (!this.signupForm.value['nationality'] && type === 'nationality')
      return 'Tap here to select';
    let _country;
    this.countryList
      .filter((c) => {
        if (type === 'nationality')
          return c.id === this.signupForm.value['nationality'];
        if (type === 'country')
          return c.id === this.signupForm.value['country'];
      })
      .map((c) => {
        _country = c;
      });
    return _country && _country.name;
  }
  async onSelectCountry(type: string) {
    let modal = await this.modalCtrl.create({
      component: CountryListPage,
      componentProps: {
        country: this.countryList,
        headerName:
          type === 'nationality' ? 'Select Nationality' : 'Select Residing In',
        excludeAll: true,
      },
    });
    modal.onDidDismiss().then((country?: any) => {

      if (country?.data) {
        let _country: Country = country.data;
        if (type === 'nationality') {
          // this.signupForm = this.fb.group({
          //     nationality:[_country.id]
          // })
          this.signupForm.value['nationality'] = _country.id;
          this.nationality.setValue(_country.id);
          // this.application.nationality.id = _country.id;
          // this.application.nationality.name = _country.name
        } else if (type === 'country') {
          this.signupForm.value['country'] = _country.id;
          this.country.setValue(_country.id);
          // this.application.nationality.id = _country.id;
          // this.application.nationality.name = _country.name
        }
      }
    });
    modal.present();
  }

  captchaResponse: string;
  resolved(captchaResponse: string) {
      console.log(`Resolved captcha with response ${captchaResponse}:`);
      this.captchaResponse = captchaResponse;
      if(this.captchaResponse && this.captchaResponse.length > 0) this.onSubmit(this.signupForm.value)
      else {
          MessageDisplayUtil.showMessageToast('Connection error. Please try again in a few moments',
          this.platform , this.toastCtl,3000, "bottom");
      }
      //  this.goQuickBook();
  }
}
